import React ,{Fragment} from 'react'
import {DropdownItem} from 'reactstrap'
const QuickActions = ({element,setCustomerObj,toggleDeleteCustomerModal}) => {
  return (
    <Fragment>
      <DropdownItem className="border-0" key={"row-delete"} onClick={()=>{
        setCustomerObj(element)
        toggleDeleteCustomerModal()
      }} >
      <i className="fa fa-trash-o"></i> Delete
      </DropdownItem>
    </Fragment>
  )
}

export default QuickActions